module.exports = __webpack_public_path__ + "static/media/spice_hero_desktop.d958fff7.jpg";